import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-participant-actions-accompagnement-card',
  templateUrl: './participant-actions-accompagnement-card.component.html',
  styleUrls: ['./participant-actions-accompagnement-card.component.scss']
})
export class ParticipantActionsAccompagnementCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
